module.exports = __webpack_public_path__ + "img/right_img.42983a2a.png";